exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo-container[data-v-75b9cc7a]{position:relative;height:0;overflow:hidden;padding-top:66%;background-size:contain;background-position:50%}", ""]);

// exports
